export default __webpack_public_path__ + "static/media/calendar.0e3ebeea.png";